import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'pl',
  fallbackLocale: 'pl',
  messages: {
    pl: {
      helloworld: 'PL',
      redirect: 'nie znaleziono danych, trwa przekierowanie',
      services: 'Usługi',
      no_data: 'Nie ma danych do wyświetlenia (korpusy nie różnią się od siebie lub wystąpił błąd)',
      menu: {
        pos: 'Częstości tagów',
        lemma: 'Najczęstsze lematy',
        lemma_dif: 'Lematy różnicujące',
        ne: 'Nazwy własne',
        term: 'Słownik terminów wielowyrazowych',
        verbs: 'Formy czasowników',
        unv: 'Usługa jeszcze nie jest dostępna',
        sentstat: 'Statystyki zdań'
      },
      table: {
        filter: 'Filtr',
        filter_placeholder: 'Wpisz aby wyszukać',
        home: {
          title: 'Podstawowe dane korpusów',
          name: 'Nazwa korpusu',
          sentences: 'Liczba zdań',
          tokens: 'Liczba tokenów'
        },
        lemma: {
          lemma: 'Lemat',
          count: 'Liczba w korpusie ',
          freq: 'Występowanie w korpusie ',
          coef: 'Współczynnik zróżnicowania',
          type: 'Typ nazwy własnej'
        }
      },
      charts: {
        scale: {
          log: 'Pokaż w skali logarytmicznej',
          lin: 'Pokaż w skali liniowej'
        },
        pos: {
          title: 'Częstości (ilości) poszczególnych tagów z NKJP',
          title_menu: 'Częstości tagów',
          title_x: 'Tag',
          title_y: 'Liczba'
        },
        base: {
          title: 'Podstawowe wymiary korpusu',
          title_menu: 'Panel funkcji',
          title_x: 'ilość',
          title_y: 'parametr'
        },
        lemma: {
          title: 'najczęściej występujące lematy dla korpusu '
        },
        lemma_dif: {
          title: 'lematy których liczebność jest najbardziej różna dla porównywanych korpusów'
        },
        ne: {
          title: 'Występowanie typów nazw własnych w korpusach',
          title_x: 'Typ',
          title_y: 'Liczba',
          nam_num: 'Nazwy numeryczne',
          nam_adj: 'Przymiotniki pochodzące od nazw własnych',
          nam_fac: 'Budynki',
          nam_liv: 'Istoty żywe',
          nam_pro: 'Produkty (wytwory ludzkie)',
          nam_loc: 'Lokalizacje',
          nam_oth: 'Pozostałe',
          nam_org: 'Organizacje i ich składowe\n',
          nam_eve: 'Wydarzenia'
        },
        verbs: {
          title: 'Występowanie form czasowników w korpusach',
          title_x: 'Typ',
          title_y: 'Liczba',
          czasownik: 'czasownik',
          czas1oslpoj: '1 osoba',
          czas1oslmn: '1 os. liczba mnoga',
          czas2oslpoj: '2 osoba',
          czas2oslmn: '2 os. liczba mnoga',
          czas3oslpoj: '3 osoba',
          czas3oslmn: '3 os. liczba mnoga',
          czasbezokolicznik: 'bezokolicznik',
          czasbezosob: 'bezosobwe',
          trybprzyp: 'tryb przypuszczający',
          trybrozk: 'tryb rozkazujący',
          czasteraz: 'czas teraźniejszy',
          czasprze: 'czas przeszły',
          czasprzy: 'czas przyszły'
        },
        sentstat: {
          tokenlen: 'Długość tokenu w znakach',
          senttokenlen: 'Długość zdania w tokenach ( bez spacji i interpunkcji )',
          sentcharlen: 'Długość zdania w znakach ( bez spacji i interpunkcji )',
          sentverblen: ' Liczba czasowników w zdaniu',
          frequency: 'Liczba wystąpień',
          mean: 'średnio:',
          lemmatokenratio: 'Współczynnik wyjątkowości:',
          ratiotitle: 'liczba unikalnych lematów przez całkowitą liczbę tokenów'
        }
      }
    },
    en: {
      helloworld: 'EN',
      redirect: 'no data found, redirection is in progress',
      services: 'Services',
      no_data: 'There is no data to display (corporas are not different or an error has occurred)',
      menu: {
        pos: 'Frequencies of tags',
        lemma: 'The most common lemmas',
        lemma_dif: 'The most differential lemmas',
        ne: 'Proper names',
        term: 'Dictionary of multiword terms',
        verbs: 'Verb forms',
        unv: 'This service is not available yet',
        sentstat: 'Sentences statistics'
      },
      table: {
        filter: 'Filter',
        filter_placeholder: 'Type to Search',
        home: {
          title: 'Basic data of corpora\'s',
          name: 'corpora\'s name',
          sentences: 'number of sentences',
          tokens: 'number of tokens'
        },
        lemma: {
          lemma: 'Lemat',
          count: 'Count in corpora ',
          freq: 'Frequency in corpora ',
          coef: 'Coefficient of differentiation',
          type: 'Proper name type'
        }
      },
      charts: {
        scale: {
          log: 'Show in logarithmic scale',
          lin: 'Show in linear scale'
        },
        pos: {
          title: 'Frequencies (quantities) of individual tags from NKJP',
          title_menu: 'Frequencies of tags',
          title_x: 'Tag',
          title_y: 'Frequency'
        },
        base: {
          title: 'Corpora default data',
          title_menu: 'Function Panel',
          title_x: 'frequency',
          title_y: 'parameter'
        },
        lemma: {
          title: 'the most common lemmas for the corpora '
        },
        lemma_dif: {
          title: 'lemmas whose number is the most different for the compared corporas'
        },
        ne: {
          title: 'occurrence of proper names types in corpora',
          title_x: 'Type',
          title_y: 'Frequency',
          nam_num: 'Numeric Names',
          nam_adj: 'Proper Adjectives  ',
          nam_fac: 'Buildings',
          nam_liv: 'Live beings',
          nam_pro: 'Products',
          nam_loc: 'Locations',
          nam_oth: 'Others',
          nam_org: 'Organizations and their parts ',
          nam_eve: 'Events'
        },
        verbs: {
          title: 'Occurrence of verb forms in corporas',
          title_x: 'Type',
          title_y: 'Frequency',
          czasownik: 'verbs',
          czas1oslpoj: '1st person',
          czas1oslmn: '1st person, plural',
          czas2oslpoj: '2nd person',
          czas2oslmn: '2nd person plural',
          czas3oslpoj: '3rd person',
          czas3oslmn: '3rd person, plural',
          czasbezokolicznik: 'infinitive',
          czasbezosob: 'impersonal',
          trybprzyp: 'subjunctive',
          trybrozk: 'imperative',
          czasteraz: 'present tense',
          czasprze: 'past tense',
          czasprzy: 'future tense'
        },
        sentstat: {
          tokenlen: 'The length of the token in characters',
          senttokenlen: 'Sentence length in tokens ( without punctuation and spaces ) ',
          sentcharlen: 'Sentence length in characters ( without punctuation and spaces )',
          sentverblen: 'Number of verbs in a sentence',
          frequency: 'Frequency',
          mean: 'mean:',
          lemmatokenratio: 'Uniqueness factor:',
          ratiotitle: 'the number of unique lemmas by the total number of tokens'
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/translations.js